module.exports = __webpack_public_path__ + "static/looksart-13f281836eecbaba1e6d12abae2cc652.png";